import React from 'react';
import Helmet from 'react-helmet';
import './index.scss';

export default () => {
  const year = new Date().getFullYear();

  return (
    <div className="landing">
      <Helmet>
        <title>Double</title>
      </Helmet>
      <main>
        <div className="content">
          <img alt="double.us logo" src="./images/logo.svg" />
          <p className="intro">
            Digital Advertising <br />
            Video Monetization <br />
            Enable E-Commerce
          </p>
          <div className="patents">
            <div className="patents__container">
              <div>
                <img className="patents__flag" alt="China Flag" src="./images/flag-china.svg" />
                <br />
                <br />
                <span>Chinese Patent: ZL 201310068305.1</span>
              </div>
            </div>
            <div className="patents__container">
              <div>
                <img className="patents__flag" alt="USA Flag" src="./images/flag-us.svg" />
                <br />
                <br />
                <span>USA Patent: US 7,593,965</span>
              </div>
            </div>
          </div>
        </div>
      </main>
      <footer>
        <span>&copy; {year}, Double LLC</span>
      </footer>
    </div>
  );
};
